class ACF {
  constructor () {
    return this
  }

  // Sort select ACF send by VUEX
  public acfSort (param: string, acf: Record < string, string >) : string {
    const sortable = []
    let result = ''
    for (const item in acf) {
      sortable.push([item, acf[item]])
    }
    if (sortable.length > 0) {
      const keyAcf = Object.keys(sortable[0][1])
      const valueAcf = Object.values(sortable[0][1])
      for (let i = 0; i < keyAcf.length; i++) {
        if (keyAcf[i] === param) {
          result = valueAcf[i] as string
        }
      }
    }
    return result
  }

  // Sort selected group (== OBJECT) of ACF and normalize they key
  public SetArrayForView (value: string, param: string): string {
    const val = value as unknown
    const newArray = val as Record < string,
      string >
    const keyValues = Object.keys(newArray).map(key => {
      const newKey = key.replace(param, '')
      return {
        [newKey]: newArray[key]
      }
    })
    const final = Object.assign({}, ...keyValues)
    return final as string
  }

  // Get Data from vuex for make final view
  public SetResponseForThumbs (value: Record < string, string >): Record < string, string > {
    // Clone initial value from vueX for no deleting vueX Object ... (^^'')
    const mergedObj = {
      ...value
    }
    // Find Key && entry from the new object
    for (const [key, entry] of Object.entries(mergedObj)) {
      const valueObject = Object.values(entry)
      const removeProp = key as string
      /// Get the index of value (in front-> like ckeckbox state) for sort Object
      const valueOfSubObject = valueObject as Array < unknown >
      // Remove value from Object if is false or NULL
      if (valueOfSubObject[0] === false || valueOfSubObject[0] === null) {
        delete mergedObj[removeProp]
      } else {
        // Remove value from Object if is true but title == Pas de préférence
        if (valueOfSubObject[0] === true && valueOfSubObject[1] === 'Pas de préférence') {
          delete mergedObj[removeProp]
        }
        // Remove value from Object if is a empty string or a value usless as string
        if (typeof valueOfSubObject[0] === 'string' || valueOfSubObject instanceof String) {
          const compareSTR = valueOfSubObject[0] as string
          if (compareSTR === 'Non' || compareSTR === 'Peu importe' || compareSTR === 'Pas de préférence' || compareSTR.length === 0) {
            delete mergedObj[removeProp]
          }
        }
      }
    }
    return mergedObj
  }

  /** ******************Use only for sort value in menu */
  public SetValueMenu (value: Record < string, string >): string {
    const response = []
    for (const [key, entry] of Object.entries(value)) {
      const valueObject = Object.values(entry)
      if (key === 'bedroom') {
        value[key] = valueObject[0] as string + ' ch.'
        response.push(' ' + value[key])
      } else {
        response.push(' ' + valueObject[1])
      }
    }
    return response.join()
  }

  /** ******************Use for rewrite object as string for the input of the form */
  public SetValueForm (value: Record < string, string >): string {
    const response = []
    for (const [key, entry] of Object.entries(value)) {
      const valueObject = Object.values(entry)
      response.push(valueObject[1])
    }
    return response.join()
  }

  /** ****************************USE for final API CALL => GET THE PRICE */
  public minifyObject (value: Record < string, string >): string[] {
    // Clone initial value from front for not deleting again ... (^^'')
    const mergedObj = {
      ...value
    }
    for (const [key, entry] of Object.entries(mergedObj)) {
      const valueObject = Object.values(entry)
      const removeProp = key as string
      /// Get the index of value (in front-> like ckeckbox state) for sort Object
      const valueOfSubObject = valueObject as Array < unknown >
      if (valueOfSubObject[0] === false || valueOfSubObject[0] === null) {
        delete mergedObj[removeProp]
      } else {
        // Remove value from Object if is true but title == Pas de préférence
        if (valueOfSubObject[0] === true && valueOfSubObject[1] === 'Pas de préférence') {
          delete mergedObj[removeProp]
        }
        // Remove value from Object if is a empty string or a value usless as string
        if (typeof valueOfSubObject[0] === 'string' || valueOfSubObject instanceof String) {
          const compareSTR = valueOfSubObject[0] as string
          if (compareSTR === 'Non' || compareSTR === 'Peu importe' || compareSTR === 'Pas de préférence' || compareSTR.length === 0) {
            delete mergedObj[removeProp]
          }
        }
      }
    }
    const valueToSend = []
    for (const [key, entry] of Object.entries(mergedObj)) {
      const valueObject = Object.values(entry)
      valueToSend.push(valueObject[1])
    }
    return valueToSend
  }

  public minifyObjectOneValue (value: Record < string, string >): string {
    // Clone initial value from front for not deleting again ... (^^'')
    let valueToSend = ''
    const mergedObj = {
      ...value
    }
    for (const [key, entry] of Object.entries(mergedObj)) {
      const valueObject = Object.values(entry)
      const removeProp = key as string
      /// Get the index of value (in front-> like ckeckbox state) for sort Object
      const valueOfSubObject = valueObject as Array < unknown >
      if (valueOfSubObject[0] === false || valueOfSubObject[0] === null) {
        delete mergedObj[removeProp]
      } else {
        // Remove value from Object if is true but title == Pas de préférence
        if (valueOfSubObject[0] === true && valueOfSubObject[1] === 'Pas de préférence') {
          delete mergedObj[removeProp]
          valueToSend = 'all'
        }
        // Remove value from Object if is a empty string or a value usless as string
        if (typeof valueOfSubObject[0] === 'string' || valueOfSubObject instanceof String) {
          const compareSTR = valueOfSubObject[0] as string
          if (compareSTR === 'Non' || compareSTR === 'Peu importe' || compareSTR === 'Pas de préférence' || compareSTR.length === 0) {
            delete mergedObj[removeProp]
          }
        }
      }
    }

    for (const [key, entry] of Object.entries(mergedObj)) {
      const valueObject = Object.values(entry)
      valueToSend = valueObject[1] as string
    }

    return valueToSend
  }
}

export {
  ACF
}
